import {
	ReactElement,
	useCallback,
	useState
} from "react";
import { AlertBar, Anchor } from "client/Components";
import { UpdateWizard } from "../UpdateWizard/UpdateWizard";
import styles from "./SsoSettingsUpdate.module.less";
import { localize } from "client_legacy/ndaw/culture";

export type SsoSettingsUpdateProps = {
	requiresUpdate: boolean;
};

export const SsoSettingsUpdate = (props: SsoSettingsUpdateProps): ReactElement => {
	const { requiresUpdate } = props;

	const [showAlert, setShowAlert] = useState<boolean>(requiresUpdate);
	const [showWizard, setShowWizard] = useState<boolean>(false);

	const closeWizard = useCallback(
		(): void => {
			setShowWizard(false);
		},
		[]
	);

	const hideAlert = useCallback(
		(): void => {
			setShowAlert(false);
		},
		[]
	);

	const handleAchorClick = useCallback(
		(event: React.MouseEvent) => {
			event.preventDefault();
			setShowWizard(true);
		},
		[]
	);

	return (
		<div>
			{showAlert && (
				<AlertBar
					kind="warning"
					isInline
					isDismissable={false}
				>
					<p className={styles.text}>
						{localize("_DueToDeprecationOnTheMicrosoftSide")}
					</p>
					<Anchor
						onClick={handleAchorClick}>
						{localize("_ClickHereToUpdateTheSingleSignOnApp")}
					</Anchor>
				</AlertBar>
			)}
			{showWizard && <UpdateWizard onClose={closeWizard} onUpdateSuccess={hideAlert} />}
		</div>
	);
};

SsoSettingsUpdate.displayName = "SsoSettingsUpdate";

